<template>
  <Autocomplete
    :items="filteredCities"
    :get-label="getLabel"
    :component-item='template'
    :auto-select-one-item="false"
    :min-len="2"
    :input-attrs="options"
    @update-items='update'
    @item-selected="itemSelected"
    :wait="0"
    v-model="value"
  >
  </Autocomplete>
</template>

<script>
import Autocomplete from 'v-autocomplete';
import ItemTemplate from './ItemTemplate';

export default {
  name: 'Autosuggest',
  components: { Autocomplete, ItemTemplate },
  props: {
    cities: {
      type: Array,
      default() {
        return [];
      },
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      required: true,
    },
    initialValue: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      searchText: '',
      template: ItemTemplate,
      value: this.initialValue,
    };
  },
  methods: {
    itemSelected(item) {
      this.value = item;
      this.$emit('selected', [this.type, item]);
    },
    getLabel(item) {
      if (item) {
        return item.name;
      }
      return '';
    },
    update(text) {
      this.searchText = text;
    },
  },
  watch: {
    initialValue() {
      this.value = this.initialValue;
    },
  },
  computed: {
    filteredCities() {
      if (this.searchText !== '') {
        const search = this.searchText.toLowerCase();
        const regexp = new RegExp(`^${search}`);

        return this.cities.filter(item => search !== '' && regexp.test(item.name.toLowerCase()));
      }

      return [];
    },
  },
};
</script>

<style scope lang="scss">
#app, #auth {
/* autocomplete */
  .v-autocomplete {
    /* autocomplete list */
    .v-autocomplete-list {
      width: 300px;
      position: absolute;
      z-index: 1;
      text-align: left;
      border: none;
      border-top: none;
      max-height: 400px;
      overflow-y: auto;
      margin-top: 10px;
      background-color: #fff;
      border-radius: 5px;
      -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
      box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
      color: #4a4a4a;

      .v-autocomplete-list-item {
        cursor: pointer;
        background-color: #fff;
        padding: 10px;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background-color: #f5fbfd;
        }

        abbr {
          opacity: 0.8;
          font-size: 0.8em;
          display: block;
          font-family: sans-serif;
        }

        .name {
          font-size: 1.1rem;
        }

        .country {
          font-size: 0.9rem;
          opacity: 0.5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Autosuggest/Autosuggest.vue